import { useMemo, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { motion, AnimatePresence } from "framer-motion"

import { getNavigations, getCurrentNavigation, getHistory } from "../../slices/navigationSlice";

import { getLanguage } from "../../tools/Dictionary";

import { MdArrowRight } from "react-icons/md";
import "./BreadCrumb.css";

const BreadCrumb = (props) =>
{

  //Redux
  const ListNavigation = useSelector(getNavigations); 
  const CurrentNavigation = useSelector(getCurrentNavigation);
  const History = useSelector(getHistory);

  //Navigate
  const Navigate = useNavigate();

  //Memo
  const bread = useMemo(() => {



    //Loop tru navigation to walk back to Home

    let currentBread = [];
    let currentNav = {...CurrentNavigation};


    // Convert URL parameters to query string
    // const queryString = currentNav.urlParams
    //   ? `?${new URLSearchParams(currentNav.urlParams).toString()}`
    //   : '';


    while (currentNav){

      currentBread.push({
        label: currentNav.label,
        code: currentNav.code,
        url: `${currentNav.url}${currentNav.urlParamsText || ""}`, // Append query params to URL
        isCurrent: currentNav._id == CurrentNavigation._id ? true : false
      });


      if (currentNav.parentId){

        let parentNav;

        parentNav = History.find(n => n._id == currentNav.parentId); // eslint-disable-line no-loop-func

        if (!parentNav){
          parentNav = ListNavigation.find(n => n._id == currentNav.parentId); // eslint-disable-line no-loop-func
        }
        
        //ListNavigation.find(n => n._id == currentNav.parentId); // eslint-disable-line no-loop-func
        currentNav = parentNav;


      } else currentNav = undefined;

    }

    currentBread.reverse();

    return currentBread;

  }, [CurrentNavigation, ListNavigation, History]);


  return (
    <div className="breadcrumb_cont">
      <AnimatePresence >
        {bread.map((b, indexM) => (
          <Fragment key={indexM}>
            <motion.div 
              className={"breadcrumb_item page_noselect " + (b.isCurrent ? "" : "breadcrumb_item_active")} 
              style={{zIndex: 20 - indexM}}
              variants={{ hidden: { opacity: 0, x: -20 * (indexM + 1) }, show: { opacity: 1, x: 0 }, exit: { opacity: 0, x: -100 } }}
              initial="hidden"
              animate="show"
              exit="exit"
              onClick={() => Navigate(b.url)}>
              {b.label[getLanguage().code]}
            </motion.div>
            {!b.isCurrent &&
              <MdArrowRight />
            }
          </Fragment>
        ))}
      </AnimatePresence>
    </div>
  )

}

export default BreadCrumb;